import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { emailServiceEndPoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

import {
  getEmailTemplatesFailure,
  getEmailTemplatesRequest,
  getEmailTemplatesSuccess,
} from '../../slice/email-templates/EmailTemplates.slice';
import {
  GetEmailTemplatesRequest,
  GetEmailTemplatesResponse,
} from '../../types/EmailTemplates.types';

function* getEmailTemplatesSaga(
  action: PayloadAction<GetEmailTemplatesRequest>
) {
  try {
    const response: GetEmailTemplatesResponse = yield call(
      HTTPClient.GetRequest,
      emailServiceEndPoints.GET_EMAIL_TEMPLATES(
        action.payload.subDispositionId ?? null
      )
    );

    if (response.data) {
      yield put(getEmailTemplatesSuccess(response.data));
    } else {
      yield put(getEmailTemplatesFailure('Failed to fetch email templates'));
    }
  } catch (error: any) {
    yield put(
      getEmailTemplatesFailure(
        error.message || 'Failed to fetch email templates'
      )
    );
  }
}

export function* watchEmailTemplates() {
  yield takeLatest(getEmailTemplatesRequest.type, getEmailTemplatesSaga);
}
